import history from "App/History";
import { useQuery } from "shared/hooks/useQuery";
import StoreProducts from "./StoreProducts";
import Brands from "pages/Brands";
import SeagmCategories from "pages/SeagmCategories";

type Section = "products" | "brands" | "categories";

const SECTIONS: { key: Section; label: string }[] = [
  { key: "products", label: "Products" },
  { key: "brands", label: "Brands / Games" },
  { key: "categories", label: "Store Categories" },
];

export default function Stores() {
  const query = useQuery();
  const tab = query.get("tab") as Section | null;
  const section: Section = SECTIONS.some((s) => s.key === tab)
    ? (tab as Section)
    : "products";

  function handleSectionChange(key: Section) {
    history.push({
      pathname: "/store",
      search: key === "products" ? "" : `tab=${key}`,
    });
  }

  return (
    <>
      <div className="store-tabs store-section-tabs">
        {SECTIONS.map((s) => (
          <div
            key={s.key}
            className={`tab-item ${section === s.key ? "active" : ""}`}
            onClick={() => handleSectionChange(s.key)}
          >
            {s.label}
          </div>
        ))}
      </div>

      {section === "products" && <StoreProducts />}
      {section === "brands" && <Brands />}
      {section === "categories" && <SeagmCategories />}
    </>
  );
}
